import Modal from '@jbhi-fi/lanyard-ui/components/Modal';
import React, { useEffect, useState } from 'react';
import { styles } from './WalletQRModal.css';
import { Barcode } from '@jbhi-fi/components/src/Barcode';

type WalletQRModalProps = {
  isOpen: boolean;
  onClose: () => void;
  walletUrl?: string;
  generateAddToWalletQRCode?: (url: string) => Promise<string | undefined>;
};

export const WalletQRModal = ({ isOpen, onClose, walletUrl, generateAddToWalletQRCode }: WalletQRModalProps) => {
  const [qrCode, setQrCode] = useState('');

  useEffect(() => {
    const fetchQrCode = async () => {
      if (generateAddToWalletQRCode && walletUrl) {
        const code = await generateAddToWalletQRCode(walletUrl);
        if (code) setQrCode(code);
      }
    };
    fetchQrCode();
  }, [walletUrl]);

  return (
    <Modal show={isOpen} onClose={onClose} size="lg" customClass={styles.modal}>
      <div className={styles.container}>
        <h2>Scan the QR code with your mobile device to add to your digital wallet</h2>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', height: '330px' }}>
        <Barcode barcodeBase64={qrCode} />
      </div>
    </Modal>
  );
};
